// src/AppRouter.js
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Market from "./pages/Market";
import Profile from "./pages/Profile";
import TradeHistory from "./pages/TradeHistory";
import WalletTransaction from "./pages/WalletTransaction";
import TradeViewer from "./pages/TradeViewer";
import Deposit from "./pages/Deposit";
import Widthdrawall from "./pages/Widthdrawall";
import Help from "./pages/Help-center";
import Userinfo from "./pages/Userinfo";
import ChangePassword from "./pages/Changepassword";
import About from "./pages/About";
import StakingCreate from "./pages/create-staking";
import Login from "./pages/Login";
import Signup from "./pages/Sign-up";
import Staking from "./pages/staking";
import Term from "./pages/Term-policy";
import LiveChat from "./pages/Live-chat";
import Spot from "./pages/spot";
import News from "./pages/News";
import AdminChat from "./pages/adminchat";
const AppRouter = () => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  console.log(
    "AppRouter - isAuthenticated:",
    isAuthenticated,
    "Current Path:",
    location.pathname
  );

  return (
    <Routes>
      <Route
        path="/login"
        element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
      />
      <Route
        path="/"
        element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
      />
      <Route
        path="/tradehistory"
        element={isAuthenticated ? <TradeHistory /> : <Navigate to="/login" />}
      />
      <Route
        path="/trade"
        element={isAuthenticated ? <TradeViewer /> : <Navigate to="/login" />}
      />
      <Route
        path="/profile"
        element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
      />
      <Route
        path="/market"
        element={isAuthenticated ? <Market /> : <Navigate to="/login" />}
      />
      <Route
        path="/walletransaction"
        element={
          isAuthenticated ? <WalletTransaction /> : <Navigate to="/login" />
        }
      />
      <Route
        path="/deposit"
        element={isAuthenticated ? <Deposit /> : <Navigate to="/login" />}
      />
      <Route
        path="/widthdrawall"
        element={isAuthenticated ? <Widthdrawall /> : <Navigate to="/login" />}
      />
      <Route
        path="/userinfo"
        element={isAuthenticated ? <Userinfo /> : <Navigate to="/login" />}
      />
      <Route
        path="/changepassword"
        element={
          isAuthenticated ? <ChangePassword /> : <Navigate to="/login" />
        }
      />
      <Route
        path="/about"
        element={isAuthenticated ? <About /> : <Navigate to="/login" />}
      />

      <Route
        path="/help"
        element={isAuthenticated ? <Help /> : <Navigate to="/login" />}
      />

      <Route
        path="/create"
        element={isAuthenticated ? <StakingCreate /> : <Navigate to="/login" />}
      />
      <Route
        path="/signup"
        element={!isAuthenticated ? <Signup /> : <Navigate to="/" />}
      />
      <Route
        path="/staking"
        element={isAuthenticated ? <Staking /> : <Navigate to="/login" />}
      />
      <Route
        path="/term"
        element={isAuthenticated ? <Term /> : <Navigate to="/login" />}
      />
      <Route
        path="/livechat"
        element={isAuthenticated ? <LiveChat /> : <Navigate to="/login" />}
      />
      <Route
        path="/spot"
        element={isAuthenticated ? <Spot /> : <Navigate to="/login" />}
      />
      <Route
        path="/news"
        element={isAuthenticated ? <News /> : <Navigate to="/login" />} // Fixed to render News for authenticated users
      />
      <Route
        path="/admin-chat"
        element={isAuthenticated ? <AdminChat /> : <Navigate to="/login" />} // Fixed to render AdminChat for authenticated users
      />
      <Route
        path="/admin-chat"
        element={isAuthenticated ? <AdminChat /> : <Navigate to="/login" />} // Fixed to render News for authenticated users
      />
    </Routes>
  );
};

export default AppRouter;
